/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ExternalValidationRequirementStatus;

(function (ExternalValidationRequirementStatus) {
  ExternalValidationRequirementStatus["FAIL"] = "fail";
  ExternalValidationRequirementStatus["PENDING"] = "pending";
  ExternalValidationRequirementStatus["SUCCESS"] = "success";
  ExternalValidationRequirementStatus["NOT_STARTED"] = "not_started";
})(ExternalValidationRequirementStatus || (ExternalValidationRequirementStatus = {}));